import { patch } from "@/shared/axios";
import useBranchId from "@/shared/hooks/useBranchId";
import { useMutation } from "@tanstack/react-query";

const useChangeSessionTableMutation = () => {
  const branchId = useBranchId();
  const mutation = useMutation({
    mutationFn: ({
      orderSessionId,
      tables,
    }: {
      orderSessionId: number;
      tables: number[];
    }) =>
      patch(
        `/internal/secure/pos/v1/order/sessions/add/delete/table/to/session/${branchId}/${orderSessionId}`,
        tables
      ),
  });

  return mutation;
};

export default useChangeSessionTableMutation;
